export const getEpisodesText = (episodes: number): string => {
  const sufix = episodes > 1 ? 's' : '';

  return `${episodes} episode${sufix}`;
};
